import type { PerspectiveViewConfig } from "@/models/perspective";
import { DateTime } from "luxon";

// Type definition for the Logs Vuex Module state object.
export interface MetricsState {
  latestQueryStartedAt: DateTime | undefined;
  loading: boolean | undefined;
  shouldExecuteQuery: boolean | undefined;
  fetchLimit: number | undefined;
  streamingIsPaused: boolean | undefined;
  shouldShowTable: boolean;
  dynamicColumns: Array<string>;
  dataProcessed: number;
  dataReturned: number;
  updateWarehouse: number;
  metricsCount: number;
  hasReportedMetrics: boolean;
  tableConfiguration: PerspectiveViewConfig;
  tableSchema: Record<string, string>;
  shouldClearTable: boolean;
  applyConfiguration: boolean;
  updateMetrics: number;
  splitByAttribute: string | undefined;
  selectedMetric: string | undefined;
}

/**
 * Create a state object for the metrics module.
 * @returns A state object initialized for use in the metrics module.
 */
export function makeState(): MetricsState {
  return {
    latestQueryStartedAt: undefined,
    loading: undefined,
    shouldExecuteQuery: undefined,
    fetchLimit: undefined,
    streamingIsPaused: undefined,
    shouldShowTable: false,
    dynamicColumns: [],
    dataProcessed: 0,
    dataReturned: 0,
    updateWarehouse: 0,
    metricsCount: 0,
    hasReportedMetrics: true,
    tableConfiguration: {
      aggregates: {},
      group_by: [],
      columns: [],
      expressions: [],
      filter: [],
      plugin: "Datagrid",
      plugin_config: {
        scroll_lock: false,
        editable: false,
        columns: {},
      },
      split_by: [],
      settings: false,
      sort: [],
    },
    tableSchema: {
      name: "string",
      value: "float",
      metricType: "string",
      description: "string",
      unit: "string",
      metricTimestamp: "datetime",
      minuteTimestamp: "datetime",
      valueType: "string",
      id: "string",
      aggregationTemporality: "integer",
      isMonotonic: "boolean",
      language: "string",
      libraryName: "string",
      libraryVersion: "string",
      serviceInstanceId: "string",
      serviceName: "string",
      serviceNamespace: "string",
      serviceVersion: "string",
    },
    shouldClearTable: false,
    applyConfiguration: false,
    updateMetrics: 0,
    splitByAttribute: undefined,
    selectedMetric: undefined,
  };
}
